import { adminApi } from "../apiAdmin";
import type { OfferInputs, OfferResults } from "../types/ambassadors";

// Admin → Ambassadors: the Ambassador Calculator's saved offers (server
// lib/admin/ambassadorOffers.js). Answers come back as sent; the tab reads
// them with savedFrom() (components/admin-ambassadors/calc.ts), so a malformed
// one shows as blank fields rather than a crash.
const PATH = "/ambassador-offers";

export const ambassadorOffersApi = {
  list: () => adminApi.get<{ items?: unknown[] }>(PATH).then((r) => r.data),
  create: (inputs: OfferInputs, results: OfferResults) =>
    adminApi.post<unknown>(PATH, { inputs, results }).then((r) => r.data),
  update: (id: string, inputs: OfferInputs, results: OfferResults) =>
    adminApi.put<unknown>(`${PATH}/${encodeURIComponent(id)}`, { inputs, results }).then((r) => r.data),
  remove: (id: string) => adminApi.delete(`${PATH}/${encodeURIComponent(id)}`).then(() => undefined),
};
